import React, { FC, ReactNode, useCallback } from 'react';

import InputField from 'buyside/components/presentation/Fields/inputField';

const ElevatorPitchField: FC = () => {
  const generateCharacterCount = useCallback((value: string): ReactNode => {
    const maxCount = 190;

    const remaining = maxCount - (value ? value.length : 0);

    return (
      <small>
        {remaining}/{maxCount} characters remaining
      </small>
    );
  }, []);

  return (
    <InputField
      generateHelperElement={generateCharacterCount}
      label="Elevator Pitch"
      name="elevatorPitch"
      textAreaProps={{ rows: 3 }}
      type="textarea"
    />
  );
};

export default ElevatorPitchField;
